module.exports = __webpack_public_path__ + "static/media/user.2516a393.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/equinixIcon/user.svg
// module id = 1103
// module chunks = 49